<template>
  <div class="krs029">
    <div class="tb-list_ty2">
      <div class="tb-header">
        <div class="top clear">
          <div class="fl">
            <div class="tb_num">
              {{$i18nUtil.trans("message.ProjectInvitationManage.001","과제 가입요청 수")}} <b>{{ invitationMemberCount }}</b>
            </div>
            <div class="check_result" v-if="filter">
              <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: searchKeyword, cnt: filterInvitationMemberList.length})">
                <!-- "{{ searchKeyword }}" 검색 결과 총<b>{{ filterInvitationMemberList.length }}</b>건 -->
              </div>
              <button type="button" @click="searchReset">초기화</button>
            </div>
          </div>
        </div>
        <div class="btm clear">
          <div class="fl">
            {{ $i18nUtil.trans("message.ProjectInvitationManage.002","선택 요청자를") }}
            <button
              type="button"
              class="btn-primary-small black"
              @click="saveChanges('MEMBER')"
            >
              {{ $i18nUtil.trans("button.member.approve","멤버로 승인") }}
            </button>
            <button
              type="button"
              class="btn-primary-small black"
              @click="saveChanges('REJECT')"
            >
              {{ $i18nUtil.trans("button.join.reject","가입 거절") }}
            </button>
          </div>

          <div class="tb_sort fr">
            <div class="dropdown ty2 relative">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="disabled">{{
                    searchType == "REQ_NAME"
                      ? $i18nUtil.trans("message.ProjectInvitationManage.003.req.name","요청자")
                      : searchType == "ID"
                      ? $i18nUtil.trans("entity.user.userId","아이디")
                      : searchType == "DEPT"
                      ? $i18nUtil.trans("entity.user.affiliation","소속")
                      : $i18nUtil.trans("message.ProjectInvitationManage.003.req.invite","초대자")
                  }}</v-btn>
                </template>
                <div class="dropdown-list">
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'REQ_NAME' }"
                        @click="searchType = 'REQ_NAME'"
                      >
                        {{ $i18nUtil.trans("message.ProjectInvitationManage.003.req.name","요청자") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'ID' }"
                        @click="searchType = 'ID'"
                      >
                        {{ $i18nUtil.trans("entity.user.userId","아이디") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'DEPT' }"
                        @click="searchType = 'DEPT'"
                      >
                        {{ $i18nUtil.trans("entity.user.affiliation","소속") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'INVITE_NAME' }"
                        @click="searchType = 'INVITE_NAME'"
                      >
                        {{ $i18nUtil.trans("message.ProjectInvitationManage.003.req.invite","초대자") }}
                      </button>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
            <form action="" onsubmit="return false;">
              <div class="search_ty1">
                <input
                  type="text"
                  maxlength="20"
                  class="ico_search"
                  @focus="$event.target.placeholder = ''"
                  @focusout="$event.target.placeholder = $i18nUtil.trans('message.placeholder.keyword','검색어 입력')"
                  :placeholder="$i18nUtil.trans('message.placeholder.keyword','검색어 입력')"
                  @input="keyWord = $event.srcElement.value"
                  :value="keyWord"
                  @keyup.enter="handlerFilterInviteMember(searchType, keyWord)"
                />
                <button
                  type="reset"
                  class="input-txt-del"
                  @click="keyWord = ''"
                  v-if="keyWord != ''"
                >
                  삭제
                </button>
                <button
                  type="button"
                  class="btn_search"
                  @click="handlerFilterInviteMember(searchType, keyWord)"
                >
                  검색
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- //tb-header -->

      <v-data-table
        v-model="checkUsers"
        :headers="headers"
        :items="filterInvitationMemberList"
        :single-select="singleSelect"
        show-select
        :sort-by="'reqDate'"
        :sort-desc="true"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
        class="tb-contents"
      >
        <template v-slot:item.userName="{ item }">
          <div class="droplayer tooltipmember relative">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                  ><b>{{ item.resultName }}</b></v-btn
                >
              </template>
              <div class="dropdown-list">
                <UserTooltip :userId="item.email" />
              </div>
            </v-menu>
          </div>
        </template>

        <template v-slot:item.deptName="{ item }">
          <div class="ell-singleline">{{ item.deptName }}</div>
        </template>

        <template v-slot:item.cellPhoneNo="{ item }">
          <div class="ell-singleline">
            {{ item.cellPhoneNo }}
          </div>
        </template>
        <template v-slot:item.reqDate="{ item }">
          <div class="ell-singleline">
            {{ item.reqDate }}
          </div>
        </template>
        <template v-slot:item.reqUserName="{ item }">
          <div class="droplayer tooltipmember relative right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                  ><b>{{ item.reqUserName }}</b></v-btn
                >
              </template>
              <div class="dropdown-list">
                <UserTooltip :userId="item.reqUserId" />
              </div>
            </v-menu>
          </div>
        </template>
        <template slot="no-data">
          <div class="nodata-txt-noicon">
            <v-alert :value="true" v-if="filter">
              {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
            </v-alert>
            <v-alert :value="true" v-else>
              {{ $i18nUtil.trans("search.015","새로운 가입 요청자가 없습니다.") }}
            </v-alert>
          </div>
        </template>
      </v-data-table>

      <div class="pagination">
        <v-pagination
          v-model="page"
          circle
          :length="pageCount"
          :total-visible="7"
        ></v-pagination>
      </div>
    </div>
    <!-- //tb-list_ty1 -->

    <footer class="modal-footer">
      <!-- <button type="button" class="btn_ty1" @click="saveChanges">
        변경사항 저장
      </button> -->
    </footer>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import EventBus from "@/js/eventbus/eventBus";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
export default {
  components: {
    UserTooltip,
  },
  data() {
    return {
      keyWord: "",
      filter: false,
      approveStatus: "",
      filterInvitationMemberList: [],
      filterInvitationMemberCount: 0,
      invitationMemberList: [],
      invitationMemberCount: 0,
      searchType: "REQ_NAME",
      searchKeyword: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      singleSelect: false,
      checkUsers: [],
      headers: [
        { text: this.$i18nUtil.trans("message.ProjectInvitationManage.003.req.name","요청자"), align: "center", value: "userName", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.userId","아이디"), value: "userId", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.affiliation","소속"), align: "center", value: "deptName", sortable: false },
        {
          text: this.$i18nUtil.trans("message.ProjectInvitationManage.003.req.tel","연락처"),
          align: "center",
          value: "cellPhoneNo",
          sortable: false,
        },
        { text: this.$i18nUtil.trans("message.ProjectInvitationManage.003.req.reqDate","요청일"), align: "center", value: "reqDate", sortable: false },
        {
          text: this.$i18nUtil.trans("message.ProjectInvitationManage.003.req.name","요청자"),
          align: "center",
          value: "reqUserName",
          sortable: false,
        },
      ],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  computed: {
    ...mapState("project", ["projectInvitationMemberList"]), // 현재 초대 멤버 리스트
    ...mapState("project", ["projectInvitationMemberCount"]), // 초대 멤버의 수
    ...mapState("project", ["projectInfo"]), // 현재 정보
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  created() {
    // this.getInvitationMemberlist();
    EventBus.$off("invitationRequestMemberList");
    EventBus.$on("invitationRequestMemberList", (payload) => {
      console.log("EventBus invitationRequestMemberList", payload);
      this.invitationMemberList = payload;
      this.filterInvitationMemberList = this.invitationMemberList;
      this.invitationMemberCount = payload.length;
    });
  },
  // obj.invitationMemberList = res.result.data;
  // obj.invitationMemberCount = obj.invitationMemberList.length;
  // let resultMember = [];
  // obj.invitationMemberList.forEach((value) => {
  //   let byte = 0;
  //   let member = value;
  //   for (let i = 0; i < value.userName.length; i++) {
  //     value.userName.charCodeAt(i) > 127 ? (byte += 2) : byte++;
  //   }
  //   if (byte > 12) {
  //     member["resultUserName"] = value.userName.substring(0, 6);
  //   } else {
  //     member["resultUserName"] = value.userName;
  //   }
  //   resultMember.push(member);
  // });
  // obj.invitationMemberList = resultMember;
  methods: {
    ...mapActions("modals", ["showToast"]),
    ...mapMutations("project", ["setProjectMemberList"]),
    ...mapMutations("project", ["setProjectMemberCount"]),
    ...mapMutations("project", ["setProjectInvitationMemberList"]),
    ...mapMutations("project", ["setProjectInvitationMemberCount"]),
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    /* 초대 멤버  */
    getInvitationMemberlist() {
      let obj = this;
      let reqData = {};
      reqData.req = {
        groupId: this.info.groupId,
        joinYn: "Y",
      };
      reqData.url = "/api/cogroup/cogroupUserManage/getCogroupUserManageList";
      reqData.method = "post";
      obj
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          obj.invitationMemberList = res.result.data;
          obj.invitationMemberCount = obj.invitationMemberList.length;
          obj.filterInvitationMemberList = obj.invitationMemberList;
          obj.filterInvitationMemberCount = obj.invitationMemberCount;
          // obj.setProjectInvitationMemberList(res.result.data);
          // obj.setProjectInvitationMemberCount(res.result.count);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    saveChanges(approveStatus) {
      if (this.checkUsers.length == 0) {
        this.toastInfo.message = this.$i18nUtil.trans("message.ProjectMemberManage.007","멤버를 선택해주세요.");
        this.showToast(this.toastInfo);
        return;
        return;
      }
      const obj = this;
      if (approveStatus == "REJECT") {
        let checkUsers = this.checkUsers;
        // "AB055": "[{reqUserName}!]을 가입 거절하시겠습니까? 가입 거절 시 [{targetName}!] 에 접근할 수 없습니다. 거절 하시겠습니까?"
        let userMngMid = [];
        for (let i = 0; i < this.checkUsers.length; i++) {
          userMngMid.push(this.checkUsers[i].userMngMid);
        }
        let userName = "";
        checkUsers.forEach((value, index) => {
          userName += value.userName;
          if (index != checkUsers.length - 1) {
            userName += ",";
          }
        });
        const modalInfo = {
          title: this.$i18nUtil.trans("title.dialog.notice","알림"),
          width: "400px",
          height: "166px",
          obj: this.$modal,
          contents: this.$i18nUtil.trans("AB055", {
            reqUserName: userName,
            countMember: checkUsers.length - 1,
            targetName: this.projectInfo.project.projectName,
          }),
          button: this.$i18nUtil.trans("button.dialog.confirm","확인"),
          subButton: this.$i18nUtil.trans("button.dialog.cancel","취소"),
          data: userMngMid,
          dialogType: "REQUEST_REJECT",
          component: Dialog,
        };
        this.showModal(modalInfo);
        return;
      } else {
        //멤버로 승인
        let addCogroupUserList = [];
        let userMngMid = [];
        for (let i = 0; i < this.checkUsers.length; i++) {
          let jsonData = {};
          if (approveStatus == "MEMBER") {
            jsonData = {
              userId: this.checkUsers[i].userId,
              userGrade: "MEMBER",
              userKbn: "01",
            };
          } else {
            jsonData = {
              userId: this.checkUsers[i].userId,
              userGrade: "MANAGER",
              userKbn: "01",
            };
          }
          addCogroupUserList.push(jsonData);
          userMngMid.push(this.checkUsers[i].userMngMid);
        }
        const reqData = {
          url: "/api/cogroup/cogroupUser/registCogroupUser",
          method: "post",
          obj: obj,
          req: {
            groupId: obj.info.groupId,
            addCogroupUserList: addCogroupUserList,
            userMngMid: userMngMid,
          },
        };
        this.loader = this.$loading.show();
        obj
          .COWORK_REST_ACTION(reqData)
          .then((res) => {
            obj.getInvitationMemberlist(obj.info.groupId);
            obj.setProjectMemberList(res.result.data);
            obj.setProjectMemberCount(res.result.countuser);
            obj.toastInfo.message = obj.$i18nUtil.trans("TB068", {
              userGradeName: approveStatus == "MEMBER" ? 
                this.$i18nUtil.trans("entity.cogroupUser.groupKbn.pro","과제 멤버") : this.$i18nUtil.trans("message.ProjectMemberManage.002.manager","운영자"),
            });
            obj.showToast(obj.toastInfo);
            obj.loader.hide();
          })
          .catch((err) => {
            console.log(err);
            console.log("[멤버추가 오류]");
            alert("[멤버추가 오류]");
          });
      }
    },
    handlerFilterInviteMember(searchType, searchKeyword) {
      if (searchKeyword == "") {
        this.toastInfo.message = this.$i18nUtil.trans("TB091");
        this.showToast(this.toastInfo);
        return;
      }
      this.searchKeyword = searchKeyword;
      this.filter = true;
      this.filterInvitationMemberList = [];
      this.invitationMemberList.forEach((value) => {
        if (this.searchKeyword) {
          if (
            searchType == "REQ_NAME" &&
            value.userName.indexOf(searchKeyword) != -1
          ) {
            this.filterInvitationMemberList.push(value);
          } else if (
            searchType == "ID" &&
            value.userId.indexOf(searchKeyword) != -1
          ) {
            this.filterInvitationMemberList.push(value);
          } else if (
            searchType == "DEPT" &&
            value.deptName.indexOf(searchKeyword) != -1
          ) {
            this.filterInvitationMemberList.push(value);
          } else if (
            searchType == "INVITE_NAME" &&
            value.reqUserName.indexOf(searchKeyword) != -1
          ) {
            this.filterInvitationMemberList.push(value);
          }
        } else {
          return;
        }
      });
    },
    searchReset() {
      this.filter = false;
      this.keyWord = "";
      this.filterInvitationMemberList = this.invitationMemberList;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/ProjectInvitationManage.vue